export default "__VITE_ASSET__CqHoCUH9__"